import type { SidebarTaskDisplayEvent } from "./taskDisplayTypes"

const zeroTime = new Date(0).toISOString()

export function runtimeFirstTaskDisplayEvent(lastEvent: SidebarTaskDisplayEvent | undefined, isRunning: boolean): SidebarTaskDisplayEvent | null {
    if (lastEvent?.status === "in_progress") return lastEvent
    if (!isRunning) return null

    if (lastEvent) {
        return {
            ...lastEvent,
            status: "in_progress",
        }
    }

    return {
        type: "action",
        status: "in_progress",
        sourceLabel: "Running",
        at: zeroTime,
    }
}
